import Option from './Option'

const {monthsMap} = Option

export default class MFileDateFormatter {
  static getMFileNameByDate (date) {
    let year = date.getFullYear()
    let month = date.getMonth()
    let week = Math.ceil(date.getDate() / 7)
    return `gdas1.${monthsMap[month]}${year % 100}.w${week}`
  }

  static getDateByMFileName (mFile) {
    let regExp = /gdas1\.([^\d]+)(\d+)\.w(\d)/g
    let results = regExp.exec(mFile)
    let month = Number(monthsMap.indexOf(results[1]))
    let yy = results[2]
    let week = Number(results[3])
    let year = [Math.floor(new Date().getFullYear() / Math.pow(10, yy.length)), yy].join('')
    let date = new Date(`${year}/01/01 00:00:00`)
    date.setMonth(month)
    date.setDate(week * 7)

    if (date.getMonth() !== month) {
      date.setDate(0)
    }

    return date
  }
}



// WEBPACK FOOTER //
// ./src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/MFileDateFormatter.js